import { useSelector } from "react-redux";
import { clientSelector } from "@/redux/clients/clients.selector";
import { columnsLiquidations, LiquidationsColumns } from "./columns";
import DataTableLiquidations from "./data-table";
import { LiquidacionesAduaneras } from "@/redux/clients/types/Clients.interface";
import { TableSkeleton } from "@/components/ui/loading";

const LiquidationsPage = () => {
  const { folderData, loading } = useSelector(clientSelector).ui;

  const dataLiquidations =
    (folderData &&
      folderData.carpetas.length > 0 &&
      folderData.carpetas[0].liquidacionesAduaneras.map(
        (liquidation: LiquidacionesAduaneras) => ({
          concepto: liquidation.concepto,
          total: liquidation.importe,
          moneda: liquidation.moneda,
        }),
      )) ||
    [];

  return (
    <div className="container pb-2 mt-2 w-full">
      {loading ? (
        <TableSkeleton rows={6} columns={3} />
      ) : (
        <DataTableLiquidations
          columns={columnsLiquidations}
          data={dataLiquidations as LiquidationsColumns[]}
        />
      )}
    </div>
  );
};

export default LiquidationsPage;
